import { useMutation } from '@apollo/client';

import { REMOVE_BEDROOM_FROM_PLACE } from '../graphql/mutation/removeBedroomFromPlaceMutation.graphql';
import { BEDROOMS } from '../graphql/query/bedroomsQuery.graphql';
import { EVENT_BEDROOMS } from '../graphql/query/eventBedroomsQuery.graphql';
import { PLACES } from '../graphql/query/placesQuery.graphql';

export const useRemoveBedroomFromPlaceMutation = (onCompleted: () => void) => {
  const [mutate] = useMutation(REMOVE_BEDROOM_FROM_PLACE, { onCompleted });

  const removeBedroomFromPlace = (bedroomId: string) => {
    mutate({
      variables: {
        bedroomId,
      },
      refetchQueries: [PLACES, BEDROOMS, EVENT_BEDROOMS],
    });
  };

  return { removeBedroomFromPlace };
};
